import React from 'react'
import '../pages/css/Home.css';
import SecOne from '../images/about-banner.png';
import SecTwo from '../images/about.png';
import { motion} from "framer-motion";
import {
  FaCheckCircle
} from "react-icons/fa"

import { useNavigate } from "react-router-dom";
function About() {
    const navigate = useNavigate();
    return (
        <><section className="hero-section text-white">
            <div className="container my-5 container-fluid">
                <div className="row align-items-center">
                    {/* Left Side */}
                    <motion.div
                        className="col-md-6 text-center text-md-start mb-4 mb-md-0"
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <h1 className="fw-bold"> <span className="highlight-text">About Us</span> </h1>
                        <p className="lead">
                           Home / <span className="highlight-text">About</span>
                        </p>
                        
                    </motion.div>

                    {/* Right Side */}
                    <motion.div
                        className="col-md-6 text-center"
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <motion.img
                            src={SecOne}
                            alt="Hero"
                            className="img-fluid rounded"
                            animate={{
                                scale: [1, 1.1, 1],
                            }}
                            transition={{
                                duration: 1.5,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                            }} />
                    </motion.div>
                </div>
            </div>
        </section>
            <section className="container my-5 container-fluid">
                <div className="row align-items-center g-5">
                    <motion.div
                        className="col-md-6 text-center"
                        initial={{ y: 100, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <img
                            src={SecTwo}
                            alt="Hero"
                            className="img-fluid rounded"
                            style={{ maxWidth: "85%" }} />
                    </motion.div>

                    <motion.div
                        className="col-md-6 text-center text-md-start mb-4 mb-md-0"
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        {/* Heading */}
                        <h1 className="fw-bold display-5 text-dark"><span className="highlight-text">About Us</span></h1>

                        {/* Subheading */}
                        <h5 className="fw-semibold text-muted" style={{ color: "#FF7F50" }}>
                            The Most Trusted Cryptocurrency Platform
                        </h5>

                        {/* Description */}
                        <p className="lead mt-3">
                            Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet

                            Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit.
                        </p>

                        {/* Tick-marked List */}
                        <ul className="list-unstyled mt-3">
                            <li className="d-flex align-items-center mb-2">
                                <FaCheckCircle className="text-success me-2" /> Stability & Long-Term Value
                            </li>
                            <li className="d-flex align-items-center mb-2">
                                <FaCheckCircle className="text-success me-2" /> Secure & Seamless Transactions
                            </li>
                            <li className="d-flex align-items-center mb-2">
                                <FaCheckCircle className="text-success me-2" /> Trusted by Investors Worldwide
                            </li>
                        </ul>

                        {/* Button */}
                        <button className="btn custom-orange-btn py-2 px-3 fw-bold mt-3" onClick={() => navigate("/login")}>
                            Get Started
                        </button>
                    </motion.div>

                </div>
            </section></>
    )
}

export default About